import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {OrderActions} from "../../../../store/actions/order.actions";
import {filter} from "rxjs/operators";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/state/app.state";
import {Product} from "../../../../store/state/order.state";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {BaseFormControlHandler} from "./form-control.handler";
import {Injectable} from "@angular/core";

@Injectable()
export class ShiftsNumberHandler extends BaseFormControlHandler {

	private readonly selectableShiftsMore: number[] = [4, 5, 6, 7, 8, 9, 10];

	constructor(private fb: FormBuilder, private store: Store<AppState>) {
		super();
	}

	buildControls(form: FormGroup, product: Product) {
		const shiftsNumberMoreControl = this.createShiftsNumberMoreControl(product);

		form.addControl(`shiftsNumber${product.standard.name}`, this.fb.control(product.shifts != null ? (product.shifts <= 3 ? product.shifts : 0) : null, [Validators.required]));
		this.addSubscription(product.standard.name, form.controls['shiftsNumber' + product.standard.name].valueChanges.subscribe(shiftsNumber => this.handleShiftsNumberChange(shiftsNumber, shiftsNumberMoreControl, form, product)));

		if (product.shifts > 3) {
			form.addControl(`shiftsNumberMore${product.standard.name}`, shiftsNumberMoreControl);
		}

		if (form.controls['shiftsNumber' + product.standard.name].value == null) {
			form.controls['shiftsNumber' + product.standard.name].setValue(1);
		}
	}

	override handleSpecificCopying(formService: FormService, controlName: string, srcForm: string, dstForm: string) {
		if (controlName == 'shiftsNumberMore') {
			const srcControl = formService.getFormControl(srcForm, 'shiftsNumberMore' + srcForm);
			const dstControl = formService.getFormControl(dstForm, 'shiftsNumberMore' + dstForm);
			const dstFormShiftsValue = formService.getValueFor('shiftsNumber' + dstForm, dstForm);

			if (formService.hasValue(srcControl) && dstFormShiftsValue == 0 && (!this.shiftsNumberMorePresent(dstControl) || formService.hasNoValue(dstControl))) {
				formService.updateFormControl('shiftsNumber' + dstForm, 0, dstForm);
				this.addControlIfNotPresent(formService.getForm(dstForm), dstForm, 'shiftsNumberMore', this.createShiftsNumberMoreControl(srcControl.value));
				formService.updateFormControl('shiftsNumberMore' + dstForm, srcControl.value, dstForm);
			}
		}
	}

	protected fillProduct(formService: FormService, srcForm: string, product: Product): void {
		const shifts = formService.getValueOrNull(srcForm, 'shiftsNumberMore');
		product.shifts = shifts != null ? shifts : formService.getValueFor('shiftsNumber', srcForm);
	}

	private shiftsNumberMorePresent(dstControl: AbstractControl) {
		return dstControl != null;
	}

	private handleShiftsNumberChange(shiftsNumber, shiftsNumberMoreControl: FormControl, form: FormGroup, product: Product) {
		if (shiftsNumber === 0) {
			const previousValue: number = shiftsNumberMoreControl.value;
			this.addControlIfNotPresent(form, product.standard.name, 'shiftsNumberMore', shiftsNumberMoreControl);
			this.store.dispatch(OrderActions.SET_SHIFTS_NUMBER({
				standardName: product.standard.name,
				shifts: previousValue
			}));
		} else if (!this.selectableShiftsMore.some(sh => sh === shiftsNumber)) {
			this.removeControlIfPresent(form, product.standard.name, 'shiftsNumberMore');
			this.store.dispatch(OrderActions.SET_SHIFTS_NUMBER({
				standardName: product.standard.name,
				shifts: shiftsNumber
			}));
		}
	}

	private createShiftsNumberMoreControl(product: Product) {
		const control = this.fb.control(this.selectableShiftsMore.some(sh => sh === product.shifts) ? product.shifts : null, [Validators.required]);
		if (product.standard != null) {
			this.addSubscription(product.standard.name, control.valueChanges.pipe(filter(shift => shift != null))
				.subscribe(shifts => {
					this.store.dispatch(OrderActions.SET_SHIFTS_NUMBER({standardName: product.standard.name, shifts}));
				}));
		}
		return control;
	}
}
